import * as React from 'react';
import { Spin } from 'antd';

function PageLoading() {
    return (

        <Spin />

    );
}

export default PageLoading;
